import React, { useMemo } from "react";
import { connect } from "dva";
import { Drivability } from "@/typedefs/vehicle";
import { ShipmentLocked } from "@/utils/enum";
import { TWICTag, EModalTag, HoldTag, HardRouteTag, ProblemRideTag, LotExitTag, DealerExchangeTag, VehicleDamagedTag, SecurePassTag, VisibilityTag, TrailerTypeTag, AutosledExpeditedTag, DirectBrokerageTag, ShipmentIncompleteStatusTag, PendingTag, } from "@/components/Tags";
const ShipmentTags = ({ shipment, securePassEnabled, hideTrailerTypeOnOpen, hideSecurePassOnDisabled, bold, }) => {
    const isDamaged = useMemo(() => (shipment?.vehicles || []).some(vehicle => vehicle.drivabilityType === Drivability.Inoperational), [shipment]);
    return (React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "flex-start" } },
        securePassEnabled && (React.createElement(SecurePassTag, { compact: false, 
            // @ts-ignore will type SecurePassTag props later
            tagStatus: shipment?.securePass ?? null, showWhenDisabled: hideSecurePassOnDisabled })),
        React.createElement(ShipmentIncompleteStatusTag, { status: shipment.incompleteStatus, bold: bold }),
        shipment.locked === ShipmentLocked.OnHold && React.createElement(HoldTag, { bold: bold }),
        isDamaged && React.createElement(VehicleDamagedTag, { bold: bold }),
        shipment.requiresLotExit && React.createElement(LotExitTag, { loadId: shipment.loadId, bold: bold }),
        React.createElement(TrailerTypeTag, { trailerType: shipment.trailerType, hideOnOpen: hideTrailerTypeOnOpen || false, bold: bold }),
        shipment.requiresTWIC && React.createElement(TWICTag, { bold: bold }),
        shipment.requiresEModal && React.createElement(EModalTag, { bold: bold }),
        shipment.isHardRoute && React.createElement(HardRouteTag, { hardRouteLocation: shipment.hardRouteReason, bold: bold }),
        shipment.isProblemRide && React.createElement(ProblemRideTag, { bold: bold }),
        shipment.isVisible === false && React.createElement(VisibilityTag, { bold: bold }),
        shipment.isExpedited && React.createElement(AutosledExpeditedTag, { bold: bold }),
        React.createElement(DealerExchangeTag, { otherLegId: shipment.childShipmentId || shipment.parentShipmentId, bold: bold }),
        shipment.isDirectBrokerage && React.createElement(DirectBrokerageTag, { bold: bold }),
        shipment.locked === ShipmentLocked.Pending && React.createElement(PendingTag, { bold: bold })));
};
ShipmentTags.defaultProps = {
    hideTrailerTypeOnOpen: true,
    bold: false,
    hideSecurePassOnDisabled: true,
};
export default connect(({ configs }) => ({
    securePassEnabled: configs.securePass.enabled,
}))(ShipmentTags);
